const DEFAULT_COVER_IMAGE = '/default-cover.jpg';
const PUBLIC_R2_DOMAIN = import.meta.env.VITE_R2_PUBLIC_BUCKET_DOMAIN || 'https://assets.eduvibz.com';

const isR2CoverKey = (value) => (
  value.startsWith('public/') ||
  value.startsWith('coverImage/') ||
  value.startsWith('music/coverImage/')
);

const normalizeSrc = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  if (isR2CoverKey(value)) {
    const key = value.replace(/^music\//, '');
    return `${PUBLIC_R2_DOMAIN.replace(/\/$/, '')}/${key}`;
  }

  return value;
};

const variantCandidates = (variants) => {
  if (!variants || typeof variants !== 'object') {
    return [];
  }

  const preferredWebp = [...(variants.webp || [])].sort((a, b) => {
    if (a.width === 640) return -1;
    if (b.width === 640) return 1;
    return Math.abs((a.width || 0) - 640) - Math.abs((b.width || 0) - 640);
  });
  const preferredJpeg = [...(variants.jpeg || [])].sort((a, b) => {
    if (a.width === 640) return -1;
    if (b.width === 640) return 1;
    return Math.abs((a.width || 0) - 640) - Math.abs((b.width || 0) - 640);
  });

  return [
    ...preferredWebp.map((variant) => variant.r2Key),
    ...preferredJpeg.map((variant) => variant.r2Key),
    variants.original?.r2Key
  ];
};

const isValidSrc = (value) => {
  if (typeof value !== 'string') {
    return false;
  }
  return value.startsWith('/') || /^https?:\/\//i.test(value) || /^data:image\//i.test(value);
};

const extractCandidates = (source) => {
  if (!source) {
    return [];
  }
  if (typeof source === 'string') {
    return [source];
  }
  return [
    ...variantCandidates(source.coverImageVariants),
    source.coverImageUrl,
    source.coverImage
  ];
};

export const getCoverImageSrc = (sources, fallback = DEFAULT_COVER_IMAGE) => {
  const list = Array.isArray(sources) ? sources : [sources];
  const candidates = list
    .filter(Boolean)
    .flatMap(extractCandidates)
    .map(normalizeSrc)
    .filter(Boolean);

  const usable = candidates.find(isValidSrc);
  return usable || fallback;
};

export const getSongCoverImageSrc = (song, fallback = DEFAULT_COVER_IMAGE) => (
  getCoverImageSrc([song, song?.chapter, song?.album], fallback)
);

export { DEFAULT_COVER_IMAGE };
